<template>
  <div v-if="message" class="notification" :class="type">
    <span>{{ message }}</span>
    <button class="close-btn" @click="closeNotification">✖</button>
  </div>
</template>

<script>
export default {
  name: "Notification",
  props: {
    message: { type: String, required: true },
    type: { type: String, default: "info" }, // 'info', 'success', 'error'
    duration: { type: Number, default: 3000 }, // in milliseconds
  },
  mounted() {
    if (this.duration) {
      setTimeout(() => {
        this.closeNotification();
      }, this.duration);
    }
  },
  methods: {
    closeNotification() {
      this.$emit("closed");
    },
  },
};
</script>

<style scoped>
.notification {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10001 !important;
  min-width: 300px;
  padding: 15px 20px;
  border-radius: 8px;
  background: rgba(31, 31, 31, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: slideIn 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.5s ease;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.notification.success {
  background: rgba(39, 174, 96, 0.95);
}
.notification.error {
  background: rgba(220, 53, 69, 0.95);
}
.notification.info {
  background: rgba(30, 136, 229, 0.95);
}
.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: var(--my-light);
}
.close-btn:hover {
  color: #000;
}
</style>
